const value = {
    searching: 'Searching...',
    noResults: 'No Results',
    manager: 'Manager IS',
    summarySubtitle: 'Any additional project info.',
  };

export default value;
